// extracted by mini-css-extract-plugin
module.exports = {"root":"SpinWrapper_root__3FbDf"};